import { Typography } from '@mui/material';

import { Placeholder } from 'modules/common/components/Placeholder';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { benefitsTranslation } from './translation';
import { useBenefitsStyles } from './useBenefitsStyles';

export interface IBenefitsProps {
  blockchains: string;
  customBlockchainsDescription?: string;
}

export const Benefits = ({
  blockchains,
  customBlockchainsDescription: blockchainsDescription,
}: IBenefitsProps) => {
  const { keys, t, tHTML } = useTranslation(benefitsTranslation);
  const { classes } = useBenefitsStyles();

  return (
    <Typography className={classes.root} component="ul" variant="body2">
      <Placeholder
        hasPlaceholder={Boolean(blockchainsDescription)}
        placeholder={
          <li dangerouslySetInnerHTML={{ __html: blockchainsDescription! }} />
        }
      >
        <li>{tHTML(keys.freeAccess, { blockchains })}</li>
      </Placeholder>
      <li>{t(keys.rateLimits)}</li>
      <li>{t(keys.usageStats)}</li>
    </Typography>
  );
};
